import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=3a187f0f&scoped=true&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ImageCarousel.vue?vue&type=style&index=0&id=3a187f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a187f0f",
  null
  
)

export default component.exports